var _linearGradient, _circle, _circle2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _linearGradient2, _circle3, _path10, _path11, _path12, _linearGradient3, _path13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCbaIncomeExpense(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 198.425 198.425",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_0_ef7bb821d732c57a599388e3ee38be7bfff270b128006917c9d9fb6697ddf242",
    gradientUnits: "userSpaceOnUse",
    x1: 399.02,
    y1: -13.591,
    x2: 400.02,
    y2: -13.591
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "MI_4L_stroke",
    cx: 89.017,
    cy: 31.373,
    r: 2.671
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "MI_4L_stroke",
    cx: 105.874,
    cy: 31.373,
    r: 2.671
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_stroke",
    d: "M110.655 67.256s-.704-4.049-4.053-4.046c-3.35.003-4.246 4.054-4.246 4.054l8.705 6.588"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_stroke",
    d: "M102.761 73.859s.704 4.049 4.053 4.046 4.246-4.054 4.246-4.054M106.698 59.76l.003 3.45M106.715 77.905l.003 3.45"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_main",
    d: "M110.655 67.256s-.704-4.049-4.053-4.046c-3.35.003-4.246 4.054-4.246 4.054l8.705 6.588"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_main",
    d: "M102.761 73.859s.704 4.049 4.053 4.046 4.246-4.054 4.246-4.054M106.698 59.76l.003 3.45M106.715 77.905l.003 3.45"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_main",
    d: "M91.003 77.233a17.023 17.023 0 01-1.322-6.579c-.009-9.419 7.62-17.062 17.04-17.071 9.419-.009 17.062 7.62 17.071 17.04s-7.62 17.062-17.04 17.071a17.164 17.164 0 01-3.104-.279"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_stroke",
    d: "M91.599 90.709s-.704-4.049-4.053-4.046c-3.35.003-4.246 4.054-4.246 4.054l8.705 6.588"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_stroke",
    d: "M83.706 97.312s.704 4.049 4.053 4.046c3.35-.003 4.246-4.054 4.246-4.054M87.643 83.213l.003 3.45M87.659 101.358l.004 3.45"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_stroke",
    d: "M91.599 90.709s-.704-4.049-4.053-4.046c-3.35.003-4.246 4.054-4.246 4.054l8.705 6.588"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_stroke",
    d: "M83.706 97.312s.704 4.049 4.053 4.046c3.35-.003 4.246-4.054 4.246-4.054M87.643 83.213l.003 3.45M87.659 101.358l.004 3.45"
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_ef7bb821d732c57a599388e3ee38be7bfff270b128006917c9d9fb6697ddf242",
    gradientUnits: "userSpaceOnUse",
    x1: 71.659,
    y1: 89.751,
    x2: 108.27,
    y2: 89.751,
    gradientTransform: "translate(-2.366 4.423)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 87.681,
    cy: 94.092,
    r: 17.055,
    fill: "none",
    stroke: "url(#SVGID_1_ef7bb821d732c57a599388e3ee38be7bfff270b128006917c9d9fb6697ddf242)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_stroke",
    d: "M110.336 95.03h16.667M123.058 89.725l5.356 5.356-5.419 5.675"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_main",
    d: "M84.114 69.922H66.602M70.547 75.226L65.19 69.87l5.42-5.674"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_main",
    d: "M116.036 30.838h15.593c2.314 0 4.189 2.077 4.189 4.639v90.652c0 2.562-1.875 4.639-4.189 4.639H62.483c-2.314 0-4.189-2.077-4.189-4.639V35.477c0-2.562 1.875-4.639 4.189-4.639h15.931"
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_ef7bb821d732c57a599388e3ee38be7bfff270b128006917c9d9fb6697ddf242",
    gradientUnits: "userSpaceOnUse",
    x1: 78.385,
    y1: 31.277,
    x2: 116.697,
    y2: 31.277
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M115.447 39.311H79.635V27.068a3.824 3.824 0 013.824-3.824h28.164a3.824 3.824 0 013.824 3.824v12.243z",
    fill: "none",
    stroke: "url(#SVGID_2_ef7bb821d732c57a599388e3ee38be7bfff270b128006917c9d9fb6697ddf242)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCbaIncomeExpense);
export default __webpack_public_path__ + "static/media/cbaIncomeExpense.78ee57725e72498301a4af4b1e7a82de.svg";
export { ForwardRef as ReactComponent };